import { types } from "../types/types";

const eventosReducer = (state=[], action) => {

    switch (action.type) {
        case types.eventosCargados:
            return action.payload
        
        case types.eventoAgregado:
            return [ action.payload, ...state ]

        case types.eventoEditado:
            return state.map( (evento) => (
                evento._id === action.payload._id
                    ? action.payload
                    : evento
            ))
        case types.eventoEliminado:
            return state.filter( ele => ele._id !== action.payload)

        default:
            return state;
    }
}

export default eventosReducer;